export const EducationSchoolModel = [
    {
        endYear: 2019,
        major: "Science-Math",
        name: "MathayomWatsing School",
        startYear: 2013,
        type: "High School"
    }, {
        department: "Math",
        endYear: 2023,
        faculty: "Science",
        grade: 3.51,
        major: "Applied Computer Science",
        name: "King Mongkut's University of Technology Thonburi",
        startYear: 2019,
        type: "Bachelor's Degree"
    }
]